<ng-container [ngSwitch]="data.type">
  <!-- Novità -->
  <div *ngSwitchCase="'Notizia'" data-object_id="219">
    <div class="card-image-wrapper with-read-more" *ngIf="isNews(data)">
      <div class="card-body p-3 pb-5">
        <div class="category-top">
          <span class="title-xsmall-semi-bold fw-semibold">{{
            data.category
            }}</span>
        </div>
        <h3 class="card-title text-paragraph-medium u-grey-light">
          {{ data.title }}
        </h3>
        <div class="text-paragraph-card u-grey-light m-0">
          <div class="mt-1">{{ data.description | truncate : 256 }}</div>
          <div class="mt-1"></div>
          <div class="mt-1">
            <strong>Data di pubblicazione:</strong>
            {{ data.publicationDate }}
          </div>
        </div>
      </div>
      <div *ngIf="data?.image" class="card-image card-image-rounded pb-5" style="width: 130px">
        <img [src]="data.image?.url" class="img-fluid" style="border: 0px" [alt]="data.image?.alternativeText"
          [title]="data.title" />
      </div>
    </div>
    <a data-element="4942f12bf4b77e301030878aeba0cbfc" class="read-more ps-3 position-absolute bottom-0 mb-3"
      [routerLink]="[data.url]" [title]="'Vai al contenuto titolo ' + data.title">
      <span class="text">Ulteriori dettagli</span>
      <svg class="icon ms-0" aria-label="Leggi di più">
        <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
      </svg>
    </a>
  </div>
  <!-- Servizio -->
  <div *ngSwitchCase="'Servizio'" data-object_id="1044" class="force-padding">
    <div class="card-body pb-5">
      <!-- <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">{{
                      service.category
                    }}</span>
                  </div> -->
      <h3 class="card-title text-paragraph-medium u-grey-light">
        {{ data.title }}
      </h3>
      <div class="text-paragraph-card u-grey-light m-0">
        <div class="mt-1">
          {{ data.description | truncate : 256 }}
        </div>
      </div>
    </div>
    <a data-element="service-link" class="read-more" [routerLink]="[data.url]"
      [title]="'Vai al contenuto ' + data.title">
      <span class="text">Ulteriori dettagli</span>
      <svg class="icon ms-0" aria-label="Leggi di più">
        <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
      </svg>
    </a>
  </div>
  <!-- Informazione -->
  <div *ngSwitchCase="'Informazione'" data-object_id="1044" class="force-padding">
    <div class="card-body pb-5">
      <!-- <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">{{
                      service.category
                    }}</span>
                  </div> -->
      <h3 class="card-title text-paragraph-medium u-grey-light">
        {{ data.title }}
      </h3>
      <div class="text-paragraph-card u-grey-light m-0">
        <div class="mt-1">
          {{ data.description | truncate : 256 }}
        </div>
      </div>
    </div>
    <a data-element="information-link" class="read-more" [routerLink]="[data.url]"
      [title]="'Vai al contenuto ' + data.title">
      <span class="text">Ulteriori dettagli</span>
      <svg class="icon ms-0" aria-label="Leggi di più">
        <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
      </svg>
    </a>
  </div>
  <div *ngSwitchCase="'Unità'" data-object_id="1044" class="force-padding">
    <div class="card-body pb-5">
      <!-- <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">{{
                      service.category
                    }}</span>
                  </div> -->
      <h3 class="card-title text-paragraph-medium u-grey-light">
        {{ data.title }}
      </h3>
      <div class="text-paragraph-card u-grey-light m-0">
        <div class="mt-1">
          {{ data.description }}
        </div>
      </div>
    </div>
    <a data-element="service-link" class="read-more" [routerLink]="[data.url]"
      [title]="'Vai al contenuto ' + data.title">
      <span class="text">Ulteriori dettagli</span>
      <svg class="icon ms-0" aria-label="Leggi di più">
        <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
      </svg>
    </a>
  </div>
  <div *ngSwitchCase="'Luogo'" data-object_id="1044"
    class="card-wrapper h-100 rounded cmp-list-card-img cmp-list-card-img-hr">
    <div class="card no-after rounded bg-white" *ngIf="isPlace(data)">
      <div class="row g-2 g-md-0 flex-md-column">
        <div class="col-4 order-2 order-md-1 position-relative" *ngIf="data?.image">
          <img [src]="data.image?.url" class="img-fluid rounded-top img-fluid img-responsive" style="border: 0px"
            [alt]="data.image?.alternativeText" [title]="data.title" />
        </div>
        <div class="col-8 order-1 order-md-2">
          <div class="card-body pb-5">
            <h3 class="card-title">
              <a data-element="c53620a352af22116f2da5f33c977a02" class="text-decoration-none"
                [routerLink]="[data.url]">{{ data.title }}</a>
            </h3>
            <div class="card-text pb-3 d-none d-md-block">
              <div>
                <p>{{ data.description }}</p>
              </div>
            </div>
            <a class="read-more" [routerLink]="[data.url]">
              <span class="text">Leggi di più</span>
              <svg class="icon" aria-label="Leggi di più">
                <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'Evento'" data-object_id="1553"
    class="card-wrapper h-100 rounded cmp-list-card-img cmp-list-card-img-hr">
    <div class="card no-after rounded bg-white" *ngIf="isEvent(data)">
      <div class="row g-2 g-md-0 flex-md-column">
        <div class="col-4 order-2 order-md-1 position-relative" *ngIf="data?.image">
          <div class="card-calendar d-flex flex-column justify-content-center">
            <span class="card-date">{{ data.date | date : "dd" }}</span>
            <span class="card-day">{{ data.date | date : "MMMM" }}</span>
          </div>
          <img [src]="data.image?.url" class="img-fluid rounded-top img-fluid img-responsive" style="border: 0px"
            [alt]="data.image?.alternativeText" [title]="data.title" />
        </div>
        <div class="col-8 order-1 order-md-2">
          <div class="card-body pb-5">
            <h3 class="card-title">
              <a data-element="2d42e178decbbeca65d64ae2b56db61b" class="text-decoration-none"
                [routerLink]="[data.url]">{{ data.title }}</a>
            </h3>
            <div class="card-text pb-3 d-none d-md-block">
              <div>
                <p>
                  {{ data.description }}
                </p>
              </div>
            </div>
            <a class="read-more" [routerLink]="[data.url]">
              <span class="text">Leggi di più</span>
              <svg class="icon" aria-label="Leggi di più">
                <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'Documento'" class="force-padding" data-object_id="1044">
    <div class="card-body pb-5">
      <div class="categoryicon-top">
        <svg class="icon icon-sm" aria-hidden="true" focusable="false">
          <use xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-file"></use>
        </svg>
        <span class="text fw-semibold">{{ data.category }}</span>
      </div>
      <h3 class="card-title text-paragraph-medium u-grey-light">
        <a data-element="d1928ade9015423b147f5ed6b2ac8705" class="text-decoration-none stretched-link"
          [routerLink]="[data.url]" [title]="'Vai al contenuto ' + data.title">
          {{ data.title }}
        </a>
      </h3>
      <div class="card-text">
        <div class="mt-1">{{ data.description }}</div>
      </div>
    </div>
  </div>
  <div *ngSwitchDefault>
    <!-- Codice HTML di fallback per altri tipi -->
  </div>
</ng-container>